'use strict';

var tooltip = require('../../../../../../../../../../_virtual/tooltip.cjs');
var intentionColors = require('../../base/ds5/intentionColors.cjs');

var hasRequiredTooltip;

function requireTooltip () {
	if (hasRequiredTooltip) return tooltip.__exports;
	hasRequiredTooltip = 1;

	var intentionColors$1 = intentionColors.__require();

	var TOOLTIP_INTENTIONS = /*#__PURE__*/ function(TOOLTIP_INTENTIONS) {
	    TOOLTIP_INTENTIONS[TOOLTIP_INTENTIONS["neutral"] = intentionColors$1.INTENTION_COLORS.neutral] = "neutral";
	    TOOLTIP_INTENTIONS[TOOLTIP_INTENTIONS["inverse"] = intentionColors$1.INTENTION_COLORS.inverse] = "inverse";
	    return TOOLTIP_INTENTIONS;
	}({});

	tooltip.__exports.TOOLTIP_INTENTIONS = TOOLTIP_INTENTIONS;
	
	return tooltip.__exports;
}

exports.__require = requireTooltip;
//# sourceMappingURL=tooltip.cjs.map
